import { storageConfig } from "../config";

function getObjectFromKey(key) {
	try {
		const result = localStorage.getItem(key);

		return JSON.parse(result);
	} catch (_) {
		return {};
	}
}
function getKey(key) {
	try {
		return localStorage.getItem(key);
	} catch (_) {
		return undefined;
	}
}
function setKey(key, value) {
	try {
		return localStorage.setItem(key, value);
	} catch (_) {
		return undefined;
	}
}
function storeState(value) {
	try {
		const result = JSON.stringify(value);

		return localStorage.setItem(storageConfig.keys.state, result);
	} catch (_) {
		return {};
	}
}

export default {
	setState(value) {
		const state = getObjectFromKey(storageConfig.keys.state);

		if (!state) {
			storeState(value);
			return;
		}

		storeState({
			...state,
			...value,
			chatbot: {
				...state.chatbot,
				...(value.chatbot || []),
			},
			team: {
				...state.team,
				...(value.team || []),
			},
			settings: {
				...state.settings,
				...(value.settings || []),
			},
			style: {
				...state.style,
				...(value.style || []),
			},
			user: {
				...state.user,
				...(value.user || []),
			},
		});
	},
	getState: () => getObjectFromKey(storageConfig.keys.state),
	getIdentity: () => getKey(storageConfig.keys.uniqueIdentifier),
	setIdentity: (id) => setKey(storageConfig.keys.uniqueIdentifier, id),
};
